import React, { createContext, Dispatch, FC, SetStateAction, useMemo, useState } from 'react';

import { InviteFormComponent } from '@/components/Steps/InviteTeamStep/InviteFormComponent';
import { FlowModel } from '@/models/flow.model';


export const InviteStepCtx = createContext<{
  didCopyLink: boolean, setDidCopyLink: Dispatch<SetStateAction<boolean>>
}>(
  {
    didCopyLink: false,
    setDidCopyLink: () => ({}),
  },
);

export const InviteTeamStep: FC<{ flow: FlowModel }> = ({ flow }) => {
  const [didCopyLink, setDidCopyLink] = useState(false);
  const inviteStepContextValue = useMemo(() => ({ didCopyLink, setDidCopyLink }), [didCopyLink, setDidCopyLink]);

  return (
    <InviteStepCtx.Provider value={ inviteStepContextValue }>
      <InviteFormComponent flow={ flow } />
    </InviteStepCtx.Provider>
  );
};
